var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 0H6.25C2.73438 0 0 2.84894 0 6.28731V34.482C0 37.9204 2.73438 40.6711 6.25 40.6711H15.625V48.8249C15.625 49.8073 16.6992 50.2985 17.4805 49.8073L29.6875 40.8675H43.75C47.168 40.8675 50 38.0186 50 34.5802V6.28731C50 2.84894 47.168 0 43.75 0ZM45.3125 34.5802C45.3125 35.4644 44.5312 36.152 43.75 36.152H28.125L20.3125 42.0464V36.152H6.25C5.37109 36.152 4.6875 35.4644 4.6875 34.5802V6.28731C4.6875 5.5014 5.37109 4.71548 6.25 4.71548H43.75C44.5312 4.71548 45.3125 5.5014 45.3125 6.28731V34.5802ZM32.8125 12.4764C31.8359 11.5922 30.3711 11.5922 29.4922 12.4764L25 17.1919L20.3125 12.4764C19.3359 11.5922 17.8711 11.5922 16.9922 12.4764C16.0156 13.4588 16.0156 14.9324 16.9922 15.8165L21.6797 20.4338L17.0898 25.051C16.1133 26.0334 16.1133 27.507 17.0898 28.3911C17.9688 29.3735 19.4336 29.3735 20.3125 28.3911L25 23.7739L29.5898 28.3911C30.4688 29.3735 31.9336 29.3735 32.8125 28.3911C33.7891 27.507 33.7891 26.0334 32.8125 25.051L28.2227 20.4338L32.8125 15.8165C33.7891 14.9324 33.7891 13.4588 32.8125 12.4764Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat);
export default __webpack_public_path__ + "static/media/NoChat.b8e0bad009fd2c692096899a462f228b.svg";
export { ForwardRef as ReactComponent };